import React from "react";
import ResourceWorkspace from "./workspace/ResourceWorkspace";

const ResourceWorkspaceRoute = () => <ResourceWorkspace />;

export default ResourceWorkspaceRoute;
